import React from 'react';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children?: React.ReactNode;
}

export default function IconButton({ children, className = '', ...rest }: IconButtonProps) {
    const classes = ['icon-btn', className].filter(Boolean).join(' ');
    return (
        <button {...rest} className={classes}>
            {children}
        </button>
    );
}
